namespace RioERP.Enquiry {
    export interface AssignEnquiryForm {
        OrderIds: Serenity.StringEditor;
        HandledBy: Serenity.LookupEditor;
    }

    export class AssignEnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.AssignEnquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AssignEnquiryForm.init)  {
                AssignEnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(AssignEnquiryForm, [
                    'OrderIds', w0,
                    'HandledBy', w1
                ]);
            }
        }
    }
}
